import {NavLink, useLocation, useParams} from "react-router-dom";
import './_style.css'
// import featData from "./_features_sample"
import {useContext, useEffect, useRef, useState} from "react";
import PaginationBar from "../../components/PaginationBar"
import FeatFilterBlock from "./FeatsListFilterBlock";
import AuthContext from "../../context/AuthContext";
import {ICatGridFilter, IFeatGridFilter, IFeatGridQuery} from "../../helpers/Interfaces";
import Footer from "../../components/Footer";
import BreadCrumbs from "../../components/BreadCrumbs";
import CircularProgress from '@mui/material/CircularProgress';
import * as React from "react";
import SearchIcon from '@mui/icons-material/Search';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddCardIcon from '@mui/icons-material/AddCard';
import {LightTooltip} from "../_subcomponents/MapToolsBase";
import PausePresentationIcon from '@mui/icons-material/PausePresentation';
import DialogParkSrcFeat from "../_subcomponents/DialogParkSrcFeat"


{/* IMPORTANT EXPLANATION !
NonIcecat taxonomy have LONG names, oftenly paths, so there are 2 types of grids:
 - Icecat taxonomy grid, either "source" or "target", with CatIDs and FeatIDs
 - NonIcecat taxonomy grid, either "source" or "target", but WITHOUT CatIDs and FeatIDs
 */}


function FeatsCircularProgress({mapScore}: any) {

    let barColor: any = 'primary.main'
    if (mapScore === 0) {
        barColor = '#f2f2f2'
    }  else if (mapScore > 0 && mapScore < 10) {
        barColor = '#b30000'
    } else if (mapScore >= 10 && mapScore < 30) {
        barColor = '#cc6600'
    } else if (mapScore >= 30 && mapScore < 50) {
        barColor = '#cccc00'
    } else if (mapScore >= 50 && mapScore < 70) {
        barColor = '#86b300'
    } else if (mapScore >= 70) {
        barColor = '#008020'
    }

    return <CircularProgress size={20} thickness={7} variant="determinate" style={{'color': barColor}} value={mapScore == 0 ? 100 : mapScore}/>
}


// Header of the Icecat taxonomy grid
function IceFeatsGridHeader({taxType}: any) {
    return (
        <div className="grid-base grid-header ice-feats-grid-columns">
            <div>#</div>
            <div>Taxonomy</div>
            <div>Category ID</div>
            <div>Category Name</div>
            <div>Feature ID</div>
            <div>Feature Name</div>
            <div>Type</div>
            <div>LOVs</div>
            <div>Class</div>
            <div>{taxType == 'target' ? <>Processed</> : <>Actions</>}</div>
        </div>
    )
}

// Header of the NonIcecat taxonomy grid
function NonIceFeatsGridHeader({taxType}: any) {
    return (
        <div className="grid-base grid-header noice-feats-grid-columns">
            <div>#</div>
            <div>Taxonomy</div>
            <div>Category Name</div>
            <div>Feature Name</div>
            <div>Type</div>
            <div>LOVs</div>
            <div>Class</div>
            <div>{taxType == 'target' ? <>Processed</> : <>Actions</>}</div>
        </div>
    )
}


// One Row (a piece) of the Categories List Table
function FeatGridRow(props: any) {

    const {num, featObj, prjid, taxType, taxName, featUIDsMapCount, featUIDsDefmapped, userPermissions, setParkFeatDial} = props

    // 'function FuncName()' is a React Component and NOT a classic JS function,
    // the below is the JS function inside the React:
    const nameReducer = (f_str: any, max_len: number) => {
        if (f_str && f_str.length > max_len) {
            f_str = f_str.slice(0, max_len) + '...'
        }
        return f_str
    }

    // let shortenCatName = nameReducer(featObj.catName, 28)
    // let shortenFeatID = nameReducer(featObj.features.featID, 24)
    // let shortenFeatName = nameReducer(featObj.features.featName, 60)
    // console.log(thisCatName)

    let gridClassName = taxName === "Icecat" ? "grid-base grid-row ice-feats-grid-columns" : "grid-base grid-row noice-feats-grid-columns"

    // let totalFeatLOVs = featObj.features?.featLOVs === undefined  ? 1 : featObj.features?.featLOVs
    // console.log(typeof  totalFeatLOVs)

    let totalFeatLOVs: number = 1
    if (featObj.features?.featLOVs) {
        totalFeatLOVs = featObj.features?.featLOVs
    }

    let thisFeatUID = featObj.features.featUID

    let commonCols1: any = <>
        <div>{num}</div>
        <div>{taxName}</div>
        {taxName === "Icecat" && <div className="cell-value-id">{featObj.catID}</div>}
        <div className="cell-value-name">{featObj.catName}</div>
        {taxName === "Icecat" && <div className="cell-value-id">{featObj.features.featID}</div>}
    </>

    const userCanEdit: boolean = Boolean(userPermissions?.canEdit)

    function handleSrcParkClick() {
        if ( userCanEdit || !userCanEdit && featObj.mapStatus == 'parked' ) {
            setParkFeatDial((prev: any) => {
                return {...prev, isOpen: true, srcFeatObj: featObj}
            })
        } else {
            // no action needed
        }
    }

    // MAIN IF-ELSE (TARGET-SOURCE) PART
    if (taxType === 'target') {

        let mappedLOVsNum: number = 0
        try {
            mappedLOVsNum = parseInt(featObj['totalMapped'])
        } catch (e) {}
        // if (featUIDsMapCount && thisFeatUID in featUIDsMapCount) {
        //     mappedLOVsNum = featUIDsMapCount[thisFeatUID]
        // } else {mappedLOVsNum = 0}

        let isFeatDefault = false
        try {
            isFeatDefault = featObj['isDefault']
        } catch (e) {}

        // let isFeatDefMapped = featUIDsDefmapped?.length > 0 && !!featUIDsDefmapped.includes(thisFeatUID)

        let mapScore = Math.round((parseInt(String(mappedLOVsNum)) / totalFeatLOVs) * 100)
        let featLink = featObj.features.featLOVs ? `../../feats/${featObj.catUID}/${featObj.features.featUID}/values/1` : // if no values, then value_pk === 0 for URL
            `../../feats/map/${featObj.catUID}/${featObj.features.featUID}/0`

        return (
            <div className={gridClassName}>
                {commonCols1}
                <div className="grid-row-itemlink">
                    <NavLink to={featLink}>{featObj.features.featName}</NavLink>
                </div>
                <div>{featObj.features.featType}</div>
                <div>{totalFeatLOVs === 1 ? '-' : totalFeatLOVs}</div>
                <div>{featObj.features.featStatus}

                </div>
                <div style={{position: 'relative', paddingTop: '4px'}}>
                    <div>
                        <FeatsCircularProgress mapScore={mapScore} style={{position: 'relative'}}/>
                            <sup style={{position: 'absolute', top: 14, left: 7, bottom: 0, right: 0}}>{isFeatDefault ? `d` : ''}</sup>
                    </div>

                    <div style={{top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.6rem', paddingLeft: '20px'}}>
                        {mapScore}% ({mappedLOVsNum}/{totalFeatLOVs})
                    </div>

                </div>
            </div>
        )

    } else {     // taxType === 'source'
        const usemapLink = `../../feats/map/${featObj.catUID}/${featObj.features.featUID}/usemap`
        const valsLink = `../../feats/${featObj.catUID}/${featObj.features.featUID}/values/1`    // returns either LOVs or Samples
        const usageLink = `../../feats/${featObj.catUID}/${featObj.features.featUID}/srcusage`

        let styleUsageIcon = {}
        if (featObj.mapStatus == 'parked') {
            styleUsageIcon = {color: 'grey', cursor: 'auto'}
        }
        else if (featObj.mapStatus == 'not mapped') {
            styleUsageIcon = {color: 'grey', cursor: 'pointer'}
        }
        else if (featObj.mapStatus == 'mapped') {
            styleUsageIcon = {color: '#2f478e', cursor: 'pointer'}
        }

        let srcParkIconStyle = {}
        if (featObj.mapStatus == 'parked') {
            srcParkIconStyle = {
                color: '#cc0000',
                cursor: "pointer"
            }
        } else if (!userCanEdit) {
            srcParkIconStyle = {
                color: 'grey',
                cursor: "auto"
            }
        } else {
            srcParkIconStyle = {
                color: '#2f478e',
                cursor: "pointer"
            }
        }

        return (
            <div className={gridClassName}>
                {commonCols1}
                <div className="cell-value-name">{featObj.features.featName}</div>
                <div>{featObj.features.featType}</div>

                <div>
                    {totalFeatLOVs === 1 ?
                        <NavLink to={valsLink} style={{paddingLeft: "10px"}}>
                            <LightTooltip title="This is NOT a dropdown/checkbox feature. Look up for SAMPLE values.">
                                <SearchIcon fontSize="small" style={{color: 'grey', fontSize: '14px'}} />
                            </LightTooltip>
                        </NavLink>
                        :
                    <NavLink to={valsLink} style={{textDecoration: 'underline', fontWeight: 'bold', paddingLeft: "12px"}}>{totalFeatLOVs}
                    </NavLink>}
                </div>


                <div>{featObj.features.featStatus}</div>

                <div className="noice-actions-col">

                    <NavLink to={featObj.mapStatus == 'parked' ? '' : usageLink }>
                        <LightTooltip title={featObj.mapStatus == 'parked' ? 'Action not possible. The feature is parked.' : "List of mappings where this feature is used in"}>
                           <FormatListBulletedIcon fontSize="small" style={styleUsageIcon} />
                        </LightTooltip>
                    </NavLink>

                    <NavLink to={featObj.mapStatus == 'parked' ? '' : usemapLink }>
                        <LightTooltip title={featObj.mapStatus == 'parked' ? 'Action not possible. The feature is parked.' : "Use for mapping. Source feature can be used multiple times."}>
                            <AddCardIcon fontSize="small" style={featObj.mapStatus == 'parked' ? {color: 'grey', cursor: 'auto'} : {color: '#2f478e'} } />
                        </LightTooltip>
                    </NavLink>


                    <LightTooltip title={featObj.mapStatus == 'parked' ? "The feature is parked. Click to unpark and make it available for mappings" : "Park source feature" }>
                        <PausePresentationIcon
                            fontSize="small"
                            style={srcParkIconStyle}
                            onClick={handleSrcParkClick}
                            // style={featObj.mapStatus == 'parked' ? {color: '#cc0000', cursor: "pointer"} : {color: '#2f478e', cursor: "pointer"} }
                            //     onClick={
                            //     userPermissions.canEdit ? () => setParkFeatDial((prev: any) => {
                            //         return {...prev, isOpen: true, srcFeatObj: featObj}
                            //     }
                            //     ) : setParkFeatDial({isOpen: false, srcFeatObj: {} })
                            // }
                        />
                    </LightTooltip>

                </div>

            </div>
        )
    }
}


export default function FeaturesList() {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    const {prjid, page_num} = useParams()

    // processing data when redirected after mapping is saved
    let redirectData = useLocation()
    let mapRdrFilterCatID = redirectData.state ? redirectData.state.catID : ''
    let mapRdrFilterCatName = redirectData.state ? redirectData.state.catName : ''

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Features List', 'link': ''}
    ]

    // when user clicks "Back" in browser than filters are preserved
    let preFilter = localStorage.getItem("filterFeats")
    let storFilter: ICatGridFilter | any = null
    if (preFilter) {
        storFilter = JSON.parse(preFilter)
    }

    const [pageData, setPageData] = useState<any>({
        firstPostIndx: 1,
        totalPosts: 0,
        dataList: [],
        taxName: '',
        featUIDsMapCount: {},
        featUIDsDefmapped: [],
        currentPage: null
    })

    const [filterObj, setFilterObj] = useState<IFeatGridFilter>({
        taxType: 'source',
        catID: mapRdrFilterCatID ? mapRdrFilterCatID : '',
        catName: mapRdrFilterCatName ? mapRdrFilterCatName : '',
        featID: '',
        featName: '',
        featType: '',
        featStatus: '',
        mapStatus: ''
    })

    const [queryObj, setQueryObj] = useState<IFeatGridQuery>({
        postsPerPage: 20,
        projUID: prjid,
        // currentPage: +(page_num || 1),
        currentPage: isNaN(+(page_num || 1)) ? 1 : +(page_num || 1),
        filterObj: storFilter ? storFilter : filterObj
    })


    //  getting and setting 'static' feats data: featType, featStatus  ------
    const [featStaticData, setStaticData] = useState<any>({})

    useEffect(() => {
        getFeatsDataStatic()
    }, [filterObj.taxType])

    let getFeatsDataStatic = async () => {
        let response = await fetch(`${serverIP}/getfeatsdatastatic/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projUID: prjid, taxType: filterObj.taxType}),
        })
        let data = await response.json()

        if (response.status === 200) {
            setStaticData(data)

        } else if (response.statusText === 'Unauthorized') { logoutUser() }
    }
    // ------


    // getting and setting dynamically changed (via filtering or paginating) feature data
    useEffect(() => {

        // re-sets filterObj for when user came from "Back" button in browser
        if (storFilter) {
            setFilterObj(storFilter)
        }

        getFeatsData()
    }, [queryObj])

    let getFeatsData = async () => {
        let response = await fetch(`${serverIP}/getfeatslist/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(queryObj),
        })
        let data = await response.json()

        if (response.status === 200) {
            // console.log('Feats response:', data)
            setPageData((prevState: any) => {
                return {
                    ...prevState,
                    firstPostIndx: data.firstPostIndx,
                    totalPosts: data.totalPosts,
                    dataList: data.pagePosts,
                    currentPage: data.currentPage,
                    taxName: data.taxName,
                    featUIDsMapCount: data.featUIDsMapCount,
                    featUIDsDefmapped: data.featUIDsDefmapped
                }
            })

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }
    // ------

    const paginate = (pageNumber: number) => setQueryObj(prevState => {
        return {...prevState, currentPage: pageNumber}
    });


    const [parkFeatDial, setParkFeatDial] = useState<any>({
        isOpen: false,
        srcFeatObj: {}
    });

    const rowElements = pageData.dataList.map((item: any, index: number) => {
        return <FeatGridRow
            key={index + pageData.firstPostIndx}
            num={index + 1 + pageData.firstPostIndx}
            featObj={item}
            prjid={prjid}
            taxType={queryObj.filterObj.taxType}
            taxName={pageData.taxName}
            featUIDsMapCount={pageData.featUIDsMapCount}
            featUIDsDefmapped={pageData.featUIDsDefmapped}
            userPermissions={userPermissions}
            setParkFeatDial={setParkFeatDial}
        />
    })

    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <FeatFilterBlock
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                setQueryObj={setQueryObj}
                featStaticData={featStaticData}
            />

            <div className="count-and-paginator">
                <div style={{marginLeft: '10px'}}><small><i>Listing {pageData.totalPosts} items</i></small></div>
                {/* Top Pagination */}
                <PaginationBar
                    postsPerPage={queryObj.postsPerPage}
                    totalPosts={pageData.totalPosts}
                    paginate={paginate}
                    currentPage={queryObj.currentPage}
                    parentURL={`../`}
                />
            </div>


            {/*  Table Grid -- Header  */}
            {pageData.taxName === "Icecat" ? <IceFeatsGridHeader taxType={filterObj.taxType} /> : <NonIceFeatsGridHeader taxType={filterObj.taxType} />}

            {/*  Table Grid -- Rows  */}
            <div className="grid-rows-container">
                {rowElements}
            </div>

            <DialogParkSrcFeat
                parkObj={parkFeatDial}
                setParkObj={setParkFeatDial}
                projUID={prjid}
                refreshFunc={getFeatsData}
            />

            {/*  Bottom Pagination  */}
            <PaginationBar
                postsPerPage={queryObj.postsPerPage}
                totalPosts={pageData.totalPosts}
                paginate={paginate}
                currentPage={queryObj.currentPage}
                parentURL={`../`}
            />

            <Footer/>
        </>
    )
}
